import { PropsWithChildren } from 'react';
import { Box as MuiBox, BoxProps as MuiBoxProps } from '@mui/material';

export type BoxProps = PropsWithChildren &
  MuiBoxProps & {
    flex?: boolean | string;
    layout?: 'row' | 'column';
    'layout-align'?: string;
    'layout-padding'?: boolean;
  };

export const Box: React.FC<BoxProps> = ({ children, flex, layout = 'row', component = 'div', ...boxProps }) => {
  const { 'layout-align': layoutAlign, 'layout-padding': layoutPadding, ...props } = boxProps;
  const align = layoutAlign?.split(' ');
  const justifyContent = align?.[layout === 'row' ? 0 : 1];
  const alignItems = align?.[layout === 'row' ? 1 : 0];

  return (
    <MuiBox
      component={component}
      display={!!flex || layoutAlign ? 'flex' : undefined}
      flex={typeof flex === 'string' ? flex : undefined}
      justifyContent={justifyContent}
      alignItems={alignItems}
      padding={layoutPadding ? '16px' : undefined}
      {...props}
    >
      {children}
    </MuiBox>
  );
};
